const DrupalOAuth = require("./DrupalOAuth");

module.exports = async function login(
	e,
	authContext,
	path,
	formData,
	keyName = "password"
) {
	if (typeof e !== "undefined" || e === false) {
		/**
		 * regular username/password login
		 */
		if (e) {
			e.preventDefault();
		}
		const [
			authState,
			{ dispatch, logout, checkAuth, isLoggedIn },
			[userData, setUserData],
		] = authContext;
		const auth = new DrupalOAuth(authState);
		formData = formData || new FormData(e.target);
		const token = await auth.loginUser(formData, keyName);
		if (token && token.token) {
			dispatch({
				type: "AUTHENTICATE_USER",
				payload: {
					isAuthenticated: true,
					clientId: auth.getClientId(),
					baseUrl: auth.getBaseUrl(),
				},
			});
			return true;
		} else {
			console.error("failed to login");
			return false;
		}
	} else if (typeof window !== "undefined") {
		/**
		 * auth0 login
		 */
		const loginUrl = new URL(process.env.CLF_BACKEND_URL);
		loginUrl.pathname = "/user/login";
		path && window.sessionStorage.setItem("cloverleaf_login_return_redirect", path);
		window.location.replace(loginUrl.toString());
	}
};
